module.exports = __webpack_public_path__ + "static/services-image-6_d-980b3e23ed6927050207999b2b151d59.jpg";